import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import MenuItem from './MenuItem';

const SideMenu = (props) => {
    let searchText = '';
    const beginSearch = (e) => {
        e.preventDefault();
        if (searchText.value !== '') props.history.push(`/portal/search/${searchText.value}`);
    };

    let searchForm = '';

    if (props.user.loggedInUser.Partner_Authority__c) {
        searchForm = (
            <div className="form-group">
                <div className="input-group">
                    <form onSubmit={beginSearch}>
                        <input
                            type="search"
                            className="form-control"
                            placeholder="Search for..."
                            style={{ zIndex: '0', width: '70%' }}
                            ref={(text) => {
                                searchText = text;
                            }}
                        />
                        <span className="input-group-btn">
                            <button
                                className="btn btn-default btn-primary"
                                type="submit"
                            >
                                <i className="fa fa-search" />
                            </button>
                        </span>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="sidebar-wrapper" style={{ backgroundColor: '#fff' }}>
            <div className="logo">
                <Link to="/portal" className="simple-text">
                    <h3> {props.user.loggedInUser ? props.user.loggedInUser.Account.Name : ''} </h3>
                </Link>
                {searchForm}
            </div>
            <MenuItem
                location={props.location}
                authority={props.user.loggedInUser ? props.user.loggedInUser.Partner_Authority__c : ''}
            />
        </div>);
};


SideMenu.propTypes = {
    user: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
};
SideMenu.defaultProps = {
    location: {},
    user: {},
    history: {},
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});


export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/common/SideMenu.js
// module id = 785
// module chunks = 0